import BaseNotificationController from "../../BaseNotificationController";

class BannerController extends BaseNotificationController {
  /**
   * DESNOTE: bannerData object has fields:
   *    message - required, string
   *    showCloseButton: optional, bool,
   *    showIcon: optional, bool,
   *    actions:[
   *      {
   *        text: required, string,
   *        handleClick: required, func
   *      } : optional, object
   *    ] :required, array
   *
   * Example: bannerData: {
   *    message: "This is a message!",
   *    showCloseButton: true,
   *    showIcon: true
   *    actions: [{
   *      text: "Action 1",
   *      handleClick: () => {}
   *    },
   *    ...
   *   ]
   * }
   */
  showByType = (type, data) => this.create(type, data);

  hideById = id => this.removeById(id);

  hideAll = () => this.removeAll();

  hideByType = type => this.removeByType(type);
}

export default new BannerController();
